
export default {
  appEnvironment: process.env.APP_ENV, // plugin || admin
  devStoreConfig: false,
  mockdata: {},
  api: {
    default: 'http://localhost:3333/v0',
    // default: 'https://bitcoin-api-dev.herokuapp.com/v0',
  },
  proxyBrowserDownloadPage: 'https://proxy-browser-releases.herokuapp.com/',
  proxyBrowserEnabled: true,
  features: {
    Ledger: true,
    BTC: true,
    BOT: true,
    Ebay: true,
    balanceSelling: true,
  },
  plugin: {
    // this is how much extra delay to add in running the loop when there is no authorization
    notAuthorizedIntervalDelay: 10 * 1000,
    // this is how often it checks for trades and opens the browser tabs
    backgroundInterval: 10 * 1000,
    backgroundDashboardRefreshInterval: 60 * 1000,
    paxful: {
      // this is how often to sync with the server with updated in the chat
      syncInterval: 5 * 1000,
    },
    samsclub: {
      // this is how often to sync with the server with updated in the chat
      syncInterval: 30 * 1000,
    },
  }
};



// WEBPACK FOOTER //
// ./config/config.js